<div [ngClass]="'dpa-severity severity-' + monPriority"
     [container]="'body'"
     [ngbTooltip]="(monPriority || 'Severity') | titlecase | translate">
    <span class="fas fa-circle"></span>
    <span class="fas fa-circle"></span>
    <span class="fas fa-circle"></span>
</div>
